{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2019 - 2023                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit IOUtils;

interface

type
  TPath = record
  public const
    AltDirectorySeparatorChar = '/';
    ExtensionSeparatorChar = '.';
    DirectorySeparatorChar = '\';
    VolumeSeparatorChar = ':';
  public
    class function Combine(const APath1, APath2: string): string; static;
    class function GetDirectoryName(const AFileName: string): string; static;
    class function GetExtension(const AFileName: string): string; static;
    class function GetFileName(const AFileName: string): string; static;
    class function GetFileNameWithoutExtension(const AFileName: string): string; static;
  end;

  TDirectory = record
  public
    class function GetCurrentDirectory: string; static;
  end;

implementation

uses
  SysUtils, Web;

{ TPath }

class function TPath.Combine(const APath1, APath2: string): string;
begin
  if (not APath1.IsEmpty) and (APath1.Chars[APath1.Length - 1] <> PathDelim) then
    Result := APath1 + PathDelim + APath2
  else
    Result := APath1 + APath2;
end;

class function TPath.GetDirectoryName(const AFileName: string): string;
var
  lIndex: Integer;
begin
  lIndex := AFileName.LastIndexOf(PathDelim);
  if lIndex >= 0 then
    Result := AFileName.SubString(0, lIndex)
  else
    Result := AFileName;
end;

class function TPath.GetExtension(const AFileName: string): string;
var
  lIndex: Integer;
begin
  Result := string.Empty;
  if not AFileName.IsEmpty then
  begin
    lIndex := AFileName.LastIndexOf(ExtensionSeparatorChar);
    if lIndex >= 0 then
      Result := AFileName.SubString(lIndex);
  end;
end;

class function TPath.GetFileName(const AFileName: string): string;
var
  lIndex: Integer;
begin
  if AFileName.IsEmpty then
    Result := string.Empty;

  lIndex := LastDelimiter(DirectorySeparatorChar + AltDirectorySeparatorChar + VolumeSeparatorChar, AFileName);
  if lIndex > 0 then
    Result := AFileName.Substring(lIndex)
  else
    Result := AFileName;
end;

class function TPath.GetFileNameWithoutExtension(const AFileName: string): string;
var
  lIndex: Integer;
begin
  Result := GetFileName(AFileName);
  if Result.IsEmpty then
    Result := string.Empty;

  lIndex := Result.LastIndexOf(ExtensionSeparatorChar);
  if lIndex >= 0 then
    Result := Result.Substring(0, lIndex);
end;

{ TDirectory }

class function TDirectory.GetCurrentDirectory: string;
begin
  Result := TPath.GetDirectoryName(window.document.location.href);
end;

end.
